export default {
      id: "icon--map-marker-usage",
      viewBox: "0 0 22 32",
      url: __webpack_public_path__ + "redesign-sprite.svg#icon--map-marker-usage",
      toString: function () {
        return this.url;
      }
    }